export interface SelectOptions {
  value: string;
  label: string;
}

export const INTERVALS: SelectOptions[] = [
  { value: "daily", label: "1 día" },
  { value: "fifteen_days", label: "15 días" },
  { value: "monthly", label: "Mensual" },
  { value: "quarterly", label: "Trimestral" },
  { value: "semiannually", label: "Semestral" },
  { value: "yearly", label: "Anual" },
  { value: "triennially", label: "3 años" },
];

export const INTERVALS_TEXT: Record<string, string> = {
  daily: "1 día",
  fifteen_days: "15 días",
  monthly: "Mensual",
  quarterly: "Trimestral",
  semiannually: "Semestral",
  yearly: "Anual",
  triennially: "3 años",
};

export const USER_TYPES: SelectOptions[] = [
  {
    value: "admin",
    label: "Administrador",
  },
  {
    value: "gestor",
    label: "Gestor",
  },
  {
    value: "empresa",
    label: "Empresa",
  },
  {
    value: "empleado",
    label: "Empleado",
  },
];

export const USER_TYPES_FILTER = [
  {
    value: "",
    label: "Todos",
  },
  ...USER_TYPES,
];

export const USER_TYPES_TEXT: Record<string, string> = {
  admin: "Administrador",
  gestor: "Gestor",
  empresa: "Empresa",
  empleado: "Empleado",
};

export const PAYMENT_STATUS: Record<string, string> = {
  processing: "Procesando",
  pending: "Pendiente",
  paid: "Pagado",
  failed: "Cancelado",
};

export const PAYMENT_STATUS_COLOR: Record<string, string> = {
  processing: "blue",
  pending: "orange",
  paid: "green",
  failed: "red",
};

export const IDENTITY_TYPE_OPTIONS: SelectOptions[] = [
  {
    value: "RUC",
    label: "RUC",
  },
  {
    value: "CC",
    label: "Cédula de Ciudadanía",
  },
  {
    value: "VAT",
    label: "VAT",
  },
  {
    value: "PASSPORT",
    label: "Pasaporte",
  },
  {
    value: "CE",
    label: "Cédula Extranjera",
  },
  {
    value: "DNI",
    label: "DNI",
  },
];

export const IDENTITY_TYPES_TEXT: Record<string, string> = {
  RUC: "RUC",
  CC: "Cédula de Ciudadanía",
  VAT: "VAT",
  PASSPORT: "Pasaporte",
  CE: "Cédula Extranjera",
  DNI: "DNI",
};


